export default "__VITE_ASSET__zvsnLzfu__"